import { Component, HostListener, OnInit } from '@angular/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css']
})

export class ContactComponent implements OnInit {
    submitted = false;
    contactForm = {
                    name: '',
                    email: '',
                    phone: '',
                    enquiryType: '',
                    message: ''
                  };

    activeFaq: number | null = null;
    faqs = [
      {
        question: 'What services do you provide?',
        answer:
          'I provide professional real estate services including property buying, selling, renting, investment consultation and property guidance in Kuala Lumpur and surrounding areas.'
      },
      {
        question: 'Which areas do you specialize in?',
        answer:
          'I specialize in Kuala Lumpur and surrounding areas including KLCC, Mont Kiara, Bangsar, Damansara Heights, Ampang Hilir, Sri Hartamas and other key areas across Klang Valley.'
      },
      {
        question: 'Are your consultation services free?',
        answer:
          'Initial property consultation is available to help understand your requirements and recommend suitable options. Contact me directly to discuss your specific needs.'
      },
      {
        question: 'How can I list my property with you?',
        answer:
          'You can contact me through the contact form, WhatsApp or phone. Share your property details and I will guide you through the listing and marketing process.'
      }
    ];
    toggleFaq(index: number): void {
      if (this.activeFaq === index) {
        this.activeFaq = null;
      } else {
        this.activeFaq = index;
      }
   }

   constructor() {}

    ngOnInit(): void {
        setTimeout(() => {
            this.checkReveal();
        }, 100);
    }

    @HostListener('window:scroll')
    onScroll(): void {
        this.checkReveal();
    }

    checkReveal(): void {
      var elements = document.querySelectorAll('.contact-page .reveal');
      var windowHeight = window.innerHeight;
      elements.forEach((el: any) => {
        var position = el.getBoundingClientRect().top;
        if (position < windowHeight - 60) {
            el.classList.add('active');
        }
      });
    }

    submitForm(): void {
      if (
          !this.contactForm.name ||
          !this.contactForm.email ||
          !this.contactForm.phone ||
          !this.contactForm.message
      ) {
          return;
      }
      /*
       * WhatsApp number that should receive the enquiry.
       * Format:
       * Country code + phone number
       * No +, spaces or hyphens.
       *
       * Example:
       * +60 12-345 6789
       * becomes:
       * 60123456789
       */
      const whatsappNumber = '60164079644';
    
      /*
       * Create WhatsApp message
       */
      const whatsappMessage =
        `*NEW PROPERTY ENQUIRY*%0A` +
        `%0A` +
    
        `*Name:* ${this.contactForm.name}%0A` +
    
        `*Email:* ${this.contactForm.email}%0A` +
    
        `*Phone:* ${this.contactForm.phone}%0A` +
    
        `*Interested In:* ${
            this.contactForm.enquiryType
                ? this.getEnquiryLabel(this.contactForm.enquiryType)
                : 'Not specified'
        }%0A` +
        `%0A` +
        `*Message:*%0A` +
        `${this.contactForm.message}%0A` +
        `%0A` +
        `--------------------------------%0A` +
        `Submitted from Ana Ang Property website`;

      /*
       * Open WhatsApp
       */
      const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
      window.open(
          whatsappUrl,
          '_blank'
      );
    
      /*
       * Show success message
       */
      this.submitted = true;
    
      /*
       * Optional:
       * Reset form after submission
       */
      this.contactForm = {
          name: '',
          email: '',
          phone: '',
          enquiryType: '',
          message: ''
      };
    }

   getEnquiryLabel(value: string): string {
     switch (value) {
         case 'buy':
             return 'Buying a Property';
         case 'sell':
             return 'Selling a Property';
         case 'rent':
             return 'Renting a Property';
         case 'investment':
             return 'Property Investment';
         case 'commercial':
             return 'Commercial Property';
         case 'new-project':
             return 'New Project';
         default:
             return 'Not specified';
     }
   }
}